const testEmailPatterns = {
  hirer: /^[a-zA-Z0-9-_]+\+test[a-zA-Z0-9-_.]*@myseek\.xyz$/,
  candidate:
    /^[a-zA-Z0-9-_]+\+test[a-zA-Z0-9-_.]*@(seek\.com\.au|seek\.co\.nz|seekasia\.com|myseek\.xyz)$/,
};

export default (site: string, email: string): boolean => {
  switch (true) {
    case site === 'talent':
      return testEmailPatterns.hirer.test(email);
    case site === 'seekAnz':
      return testEmailPatterns.candidate.test(email);
    default:
      return false;
  }
};
